import apolloClient from 'api/apolloClient';
import { GET_UPLOAD_EXHIBIT_ZIP_URL } from 'api/queries/carrierFileService';

export async function getUploadExhibitZipUrl(urls: string[]): Promise<string> {
  const res = await apolloClient.query<{ getUploadExhibitZipUrl: string }>({
    query: GET_UPLOAD_EXHIBIT_ZIP_URL,
    fetchPolicy: 'no-cache',
    variables: { urls },
  });
  return res.data.getUploadExhibitZipUrl;
}
